/* eslint-disable react-refresh/only-export-components */
import { lazy, Suspense } from "react";
import { RoleGate } from "./components/role-gate";
import { Loading } from "./components/ui/loading";
import { ROLE } from "./utils/constant";
import { keycloak } from "./utils/lib/keycloak";

// Microfrontends

// E2E Phase 2 Module
const HLDIndex = lazy(() => import("e2ePhase2/HLDIndex"));
const HLDImportNewData = lazy(() => import("e2ePhase2/HLDImportNewData"));
const HLDEditDataAGG = lazy(() => import("e2ePhase2/HLDEditDataAGG"));
const HLDDetail = lazy(() => import("e2ePhase2/HLDDetail"));
const HLDUpdateCanceledAGG = lazy(
  () => import("e2ePhase2/HLDUpdateCanceledAGG"),
);

//Permit Rent
const PermitRentIndex = lazy(() => import("e2ePhase2/PermitRentIndex"));
const PermitRentDetail = lazy(() => import("e2ePhase2/PermitRentDetail"));
const DetailRingDetail = lazy(() => import("e2ePhase2/DetailRingDetail"));
const DashboardPermitRent = lazy(() => import("e2ePhase2/DashboardPermitRent"));

// Permit Feeder
const PermitFeederIndex = lazy(() => import("e2ePhase2/PermitFeederIndex"));
const PermitFeederDetail = lazy(() => import("e2ePhase2/PermitFeederDetail"));
const PermitFeederDetailEntity = lazy(
  () => import("e2ePhase2/PermitFeederDetailEntity"),
);
const DashboardPermitFeeder = lazy(
  () => import("e2ePhase2/DashboardPermitFeeder"),
);

// Permit FoOlt
const PermitFoOltIndex = lazy(() => import("e2ePhase2/PermitFoOltIndex"));
const PermitFoOltDetail = lazy(() => import("e2ePhase2/PermitFoOltDetail"));
const PermitFoOltDetailEntity = lazy(
  () => import("e2ePhase2/PermitFoOltDetailEntity"),
);
const DashboardPermitFoOlt = lazy(
  () => import("e2ePhase2/DashboardPermitFoOlt"),
);

// Permit Ring BB
const PermitRingBbIndex = lazy(() => import("e2ePhase2/PermitRingBbIndex"));
const PermitRingBbSegmentDetail = lazy(
  () => import("e2ePhase2/PermitRingBbSegmentDetail"),
);
const PermitRingBbRingDetail = lazy(
  () => import("e2ePhase2/PermitRingBbRingDetail"),
);
const PermitRingBbDetailEntity = lazy(
  () => import("e2ePhase2/PermitRingBbDetailEntity"),
);
const MonitoringBbIndex = lazy(() => import("e2ePhase2/MonitoringBbIndex"));
const PermitRingBbDashboard = lazy(
  () => import("e2ePhase2/PermitRingBbDashboard"),
);

// APD BB
const APDBBIndex = lazy(() => import("e2ePhase2/APDBBIndex"));
const APDBBDetail = lazy(() => import("e2ePhase2/APDBBDetail"));
const Dashboard = lazy(() => import("e2ePhase2/APDBBDashboard"));

export const e2ePhase2Routes = [
  {
    path: "hld",
    children: [
      {
        path: "hld-list",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate roles={[ROLE.AGG_HLD, ROLE.HLD_VIEW]}>
                  <HLDIndex keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
          {
            path: ":id",
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate roles={[ROLE.AGG_HLD, ROLE.HLD_VIEW]}>
                  <HLDDetail keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "import-new-data-hld",
        element: (
          <Suspense fallback={<Loading />}>
            <RoleGate roles={[ROLE.AGG_HLD]}>
              <HLDImportNewData keycloak={keycloak} />
            </RoleGate>
          </Suspense>
        ),
      },
      {
        path: "edit-transaction-data-agg",
        element: (
          <Suspense fallback={<Loading />}>
            <RoleGate roles={[ROLE.AGG_HLD]}>
              <HLDEditDataAGG keycloak={keycloak} />
            </RoleGate>
          </Suspense>
        ),
      },
      {
        path: "update-canceled-agg",
        element: (
          <Suspense fallback={<Loading />}>
            <RoleGate roles={[ROLE.AGG_HLD]}>
              <HLDUpdateCanceledAGG keycloak={keycloak} />
            </RoleGate>
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "permit-rent",
    children: [
      {
        path: "dashboard",
        element: (
          <Suspense fallback={<Loading />}>
            <RoleGate
              roles={[
                ROLE.AGG_HLD,
                ROLE.AGG_PERMIT_MONITORING,
                ROLE.AGG_PROJECT_MANAGER,
                ROLE.AGG_OPERATIONAL_LEAD,
                ROLE.AGG_FUNNEL_PROJECT,
                ROLE.AGG_PERMIT_DISPATCH,
                ROLE.VENDOR,
                ROLE.HLD_VIEW,
                ROLE.PERMIT_AGG_VIEW,
                ROLE.VENDOR_VIEW,
              ]}
            >
              <DashboardPermitRent keycloak={keycloak} />
            </RoleGate>
          </Suspense>
        ),
      },
      {
        path: "permit-rent-list",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.AGG_HLD,
                    ROLE.AGG_PERMIT_MONITORING,
                    ROLE.AGG_PROJECT_MANAGER,
                    ROLE.AGG_OPERATIONAL_LEAD,
                    ROLE.AGG_FUNNEL_PROJECT,
                    ROLE.AGG_PERMIT_DISPATCH,
                    ROLE.VENDOR,
                    ROLE.HLD_VIEW,
                    ROLE.PERMIT_AGG_VIEW,
                    ROLE.VENDOR_VIEW,
                  ]}
                >
                  <PermitRentIndex keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
          {
            path: ":id",
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.AGG_HLD,
                    ROLE.AGG_PERMIT_MONITORING,
                    ROLE.AGG_PROJECT_MANAGER,
                    ROLE.AGG_OPERATIONAL_LEAD,
                    ROLE.AGG_FUNNEL_PROJECT,
                    ROLE.AGG_PERMIT_DISPATCH,
                    ROLE.VENDOR,
                    ROLE.HLD_VIEW,
                    ROLE.PERMIT_AGG_VIEW,
                    ROLE.VENDOR_VIEW,
                  ]}
                >
                  <PermitRentDetail keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
          {
            path: "detail-ring",
            children: [
              {
                path: ":id",
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.AGG_HLD,
                        ROLE.AGG_PERMIT_MONITORING,
                        ROLE.AGG_PROJECT_MANAGER,
                        ROLE.AGG_OPERATIONAL_LEAD,
                        ROLE.AGG_FUNNEL_PROJECT,
                        ROLE.AGG_PERMIT_DISPATCH,
                        ROLE.VENDOR,
                      ]}
                    >
                      <DetailRingDetail keycloak={keycloak} />
                    </RoleGate>
                  </Suspense>
                ),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "permit-feeder",
    children: [
      {
        path: "dashboard",
        element: (
          <Suspense fallback={<Loading />}>
            <RoleGate
              roles={[
                ROLE.VENDOR,
                ROLE.FEEDER_FUNNEL_PROJECT,
                ROLE.FEEDER_PERMIT_DISPATCH,
                ROLE.FEEDER_PERMIT_MONITORING,
                ROLE.FEEDER_HEAD_OF_PERMIT,
                ROLE.FEEDER_HEAD_OF_PROJECT,
                ROLE.PERMIT_FEEDER_VIEW,
                ROLE.VENDOR_VIEW,
              ]}
            >
              <DashboardPermitFeeder keycloak={keycloak} />
            </RoleGate>
          </Suspense>
        ),
      },
      {
        path: "permit-feeder-list",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.VENDOR,
                    ROLE.LM_FEEDER_DESIGN,
                    ROLE.FEEDER_FUNNEL_PROJECT,
                    ROLE.FEEDER_PERMIT_DISPATCH,
                    ROLE.FEEDER_PERMIT_MONITORING,
                    ROLE.FEEDER_HEAD_OF_PERMIT,
                    ROLE.FEEDER_HEAD_OF_PROJECT,
                    ROLE.PERMIT_FEEDER_VIEW,
                    ROLE.APD_VIEW,
                    ROLE.VENDOR_VIEW,
                  ]}
                >
                  <PermitFeederIndex keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
          {
            path: ":id",
            children: [
              {
                index: true,
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.VENDOR,
                        ROLE.LM_FEEDER_DESIGN,
                        ROLE.FEEDER_FUNNEL_PROJECT,
                        ROLE.FEEDER_PERMIT_DISPATCH,
                        ROLE.FEEDER_PERMIT_MONITORING,
                        ROLE.FEEDER_HEAD_OF_PERMIT,
                        ROLE.FEEDER_HEAD_OF_PROJECT,
                        ROLE.PERMIT_FEEDER_VIEW,
                        ROLE.APD_VIEW,
                        ROLE.VENDOR_VIEW,
                      ]}
                    >
                      <PermitFeederDetail keycloak={keycloak} />
                    </RoleGate>
                  </Suspense>
                ),
              },
              {
                path: "entities",
                children: [
                  {
                    path: ":entityId",
                    element: (
                      <Suspense fallback={<Loading />}>
                        <RoleGate
                          roles={[
                            ROLE.VENDOR,
                            ROLE.LM_FEEDER_DESIGN,
                            ROLE.FEEDER_FUNNEL_PROJECT,
                            ROLE.FEEDER_PERMIT_DISPATCH,
                            ROLE.FEEDER_PERMIT_MONITORING,
                            ROLE.FEEDER_HEAD_OF_PERMIT,
                            ROLE.FEEDER_HEAD_OF_PROJECT,
                            ROLE.PERMIT_FEEDER_VIEW,
                            ROLE.APD_VIEW,
                            ROLE.VENDOR_VIEW,
                          ]}
                        >
                          <PermitFeederDetailEntity keycloak={keycloak} />
                        </RoleGate>
                      </Suspense>
                    ),
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "permit-fo-olt",
    children: [
      {
        path: "dashboard",
        element: (
          <Suspense fallback={<Loading />}>
            <RoleGate
              roles={[
                ROLE.VENDOR,
                ROLE.FOOLT_FUNNEL_PROJECT,
                ROLE.FOOLT_PERMIT_DISPATCH,
                ROLE.FOOLT_PERMIT_MONITORING,
                ROLE.FOOLT_HEAD_OF_PERMIT,
                ROLE.FOOLT_HEAD_OF_PROJECT,
                ROLE.PERMIT_FOOLT_VIEW,
                ROLE.VENDOR_VIEW,
              ]}
            >
              <DashboardPermitFoOlt keycloak={keycloak} />
            </RoleGate>
          </Suspense>
        ),
      },
      {
        path: "permit-fo-olt-list",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.VENDOR,
                    ROLE.LM_FEEDER_DESIGN,
                    ROLE.FOOLT_FUNNEL_PROJECT,
                    ROLE.FOOLT_PERMIT_DISPATCH,
                    ROLE.FOOLT_PERMIT_MONITORING,
                    ROLE.FOOLT_HEAD_OF_PERMIT,
                    ROLE.FOOLT_HEAD_OF_PROJECT,
                    ROLE.PERMIT_FOOLT_VIEW,
                    ROLE.APD_VIEW,
                    ROLE.VENDOR_VIEW,
                  ]}
                >
                  <PermitFoOltIndex keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
          {
            path: ":id",
            children: [
              {
                index: true,
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.VENDOR,
                        ROLE.LM_FEEDER_DESIGN,
                        ROLE.FOOLT_FUNNEL_PROJECT,
                        ROLE.FOOLT_PERMIT_DISPATCH,
                        ROLE.FOOLT_PERMIT_MONITORING,
                        ROLE.FOOLT_HEAD_OF_PERMIT,
                        ROLE.FOOLT_HEAD_OF_PROJECT,
                        ROLE.PERMIT_FOOLT_VIEW,
                        ROLE.APD_VIEW,
                        ROLE.VENDOR_VIEW,
                      ]}
                    >
                      <PermitFoOltDetail keycloak={keycloak} />
                    </RoleGate>
                  </Suspense>
                ),
              },
              {
                path: "entities",
                children: [
                  {
                    path: ":entityId",
                    element: (
                      <Suspense fallback={<Loading />}>
                        <RoleGate
                          roles={[
                            ROLE.VENDOR,
                            ROLE.LM_FEEDER_DESIGN,
                            ROLE.FOOLT_FUNNEL_PROJECT,
                            ROLE.FOOLT_PERMIT_DISPATCH,
                            ROLE.FOOLT_PERMIT_MONITORING,
                            ROLE.FOOLT_HEAD_OF_PERMIT,
                            ROLE.FOOLT_HEAD_OF_PROJECT,
                            ROLE.PERMIT_FOOLT_VIEW,
                            ROLE.APD_VIEW,
                            ROLE.VENDOR_VIEW,
                          ]}
                        >
                          <PermitFoOltDetailEntity keycloak={keycloak} />
                        </RoleGate>
                      </Suspense>
                    ),
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "monitoring-bb-list",
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Loading />}>
            <RoleGate
              roles={[
                ROLE.AGG_HLD,
                ROLE.AGG_PERMIT_MONITORING,
                ROLE.AGG_PROJECT_MANAGER,
                ROLE.AGG_OPERATIONAL_LEAD,
                ROLE.AGG_FUNNEL_PROJECT,
                ROLE.AGG_PERMIT_DISPATCH,
                ROLE.FEEDER_FUNNEL_PROJECT,
                ROLE.FEEDER_PERMIT_DISPATCH,
                ROLE.FEEDER_PERMIT_MONITORING,
                ROLE.FEEDER_HEAD_OF_PERMIT,
                ROLE.FEEDER_HEAD_OF_PROJECT,
                ROLE.FOOLT_FUNNEL_PROJECT,
                ROLE.FOOLT_PERMIT_DISPATCH,
                ROLE.FOOLT_PERMIT_MONITORING,
                ROLE.FOOLT_HEAD_OF_PERMIT,
                ROLE.FOOLT_HEAD_OF_PROJECT,
                ROLE.RING_FUNNEL_PROJECT,
                ROLE.RING_PERMIT_DISPATCH,
                ROLE.RING_PERMIT_MONITORING,
                ROLE.RING_HEAD_OF_PERMIT,
                ROLE.RING_HEAD_OF_PROJECT,
                ROLE.VENDOR,
                ROLE.HLD_VIEW,
                ROLE.PERMIT_AGG_VIEW,
                ROLE.PERMIT_FEEDER_VIEW,
                ROLE.PERMIT_RING_VIEW,
                ROLE.PERMIT_FOOLT_VIEW,
                ROLE.VENDOR_VIEW,
              ]}
            >
              <MonitoringBbIndex keycloak={keycloak} />
            </RoleGate>
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "permit-ring-bb",
    children: [
      {
        path: "permit-ring-bb-list",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.VENDOR,
                    ROLE.RING_FUNNEL_PROJECT,
                    ROLE.RING_PERMIT_DISPATCH,
                    ROLE.RING_PERMIT_MONITORING,
                    ROLE.RING_HEAD_OF_PERMIT,
                    ROLE.RING_HEAD_OF_PROJECT,
                    ROLE.PERMIT_RING_VIEW,
                    ROLE.VENDOR_VIEW,
                  ]}
                >
                  <PermitRingBbIndex keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
          {
            path: ":id",
            children: [
              {
                index: true,
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.VENDOR,
                        ROLE.RING_FUNNEL_PROJECT,
                        ROLE.RING_PERMIT_DISPATCH,
                        ROLE.RING_PERMIT_MONITORING,
                        ROLE.RING_HEAD_OF_PERMIT,
                        ROLE.RING_HEAD_OF_PROJECT,
                        ROLE.PERMIT_RING_VIEW,
                        ROLE.VENDOR_VIEW,
                      ]}
                    >
                      <PermitRingBbSegmentDetail keycloak={keycloak} />
                    </RoleGate>
                  </Suspense>
                ),
              },
              {
                path: "entities",
                children: [
                  {
                    path: ":entityId",
                    element: (
                      <Suspense fallback={<Loading />}>
                        <RoleGate
                          roles={[
                            ROLE.VENDOR,
                            ROLE.RING_FUNNEL_PROJECT,
                            ROLE.RING_PERMIT_DISPATCH,
                            ROLE.RING_PERMIT_MONITORING,
                            ROLE.RING_HEAD_OF_PERMIT,
                            ROLE.RING_HEAD_OF_PROJECT,
                            ROLE.PERMIT_RING_VIEW,
                            ROLE.VENDOR_VIEW,
                          ]}
                        >
                          <PermitRingBbDetailEntity keycloak={keycloak} />
                        </RoleGate>
                      </Suspense>
                    ),
                  },
                ],
              },
            ],
          },
          {
            path: "detail-ring",
            children: [
              {
                path: ":ringId",
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.VENDOR,
                        ROLE.RING_FUNNEL_PROJECT,
                        ROLE.RING_PERMIT_DISPATCH,
                        ROLE.RING_PERMIT_MONITORING,
                        ROLE.RING_HEAD_OF_PERMIT,
                        ROLE.RING_HEAD_OF_PROJECT,
                        ROLE.PERMIT_RING_VIEW,
                        ROLE.VENDOR_VIEW,
                      ]}
                    >
                      <PermitRingBbRingDetail keycloak={keycloak} />
                    </RoleGate>
                  </Suspense>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "dashboard",
        element: (
          <Suspense fallback={<Loading />}>
            <RoleGate
              roles={[
                ROLE.VENDOR,
                ROLE.RING_FUNNEL_PROJECT,
                ROLE.RING_PERMIT_DISPATCH,
                ROLE.RING_PERMIT_MONITORING,
                ROLE.RING_HEAD_OF_PERMIT,
                ROLE.RING_HEAD_OF_PROJECT,
                ROLE.PERMIT_RING_VIEW,
                ROLE.VENDOR_VIEW,
              ]}
            >
              <PermitRingBbDashboard keycloak={keycloak} />
            </RoleGate>
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "permit-backbone",
    children: [
      {
        path: "apd-bb-list",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.BB_DESIGN,
                    ROLE.VENDOR,
                    ROLE.BB_COSTING,
                    ROLE.APD_BB_VIEW,
                    ROLE.VENDOR_VIEW,
                  ]}
                >
                  <APDBBIndex keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
          {
            path: ":id",
            children: [
              {
                index: true,
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.BB_DESIGN,
                        ROLE.VENDOR,
                        ROLE.BB_COSTING,
                        ROLE.APD_BB_VIEW,
                        ROLE.VENDOR_VIEW,
                      ]}
                    >
                      <APDBBDetail keycloak={keycloak} />
                    </RoleGate>
                  </Suspense>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "dashboard",
        element: (
          <Suspense fallback={<Loading />}>
            <RoleGate
              roles={[
                ROLE.BB_DESIGN,
                ROLE.VENDOR,
                ROLE.BB_COSTING,
                ROLE.APD_BB_VIEW,
                ROLE.VENDOR_VIEW,
              ]}
            >
              <Dashboard keycloak={keycloak} />
            </RoleGate>
          </Suspense>
        ),
      },
    ],
  },
];
